import { onMount, reactive, Icon } from 'cdui-js';
import type { ToastAPI } from './index';
import type { ToastPosition, ToastType } from './index';
import './style.css';

/** 对齐 App HUD：弧形转圈（CircleLoadingIndicator 36 / arc 0.72 / stroke 3） */
const HudSpinnerIcon = () => (
  <div class="f-toast__hud-spinner" aria-hidden="true">
    <svg class="f-toast__hud-icon" width="36" height="36" viewBox="0 0 36 36" fill="none">
      <circle
        class="f-toast__hud-spinner-arc"
        cx="18"
        cy="18"
        r="16.5"
        fill="none"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
      />
    </svg>
  </div>
);

/** 对齐 App HUD：tdesign_check 对勾 */
const HudSuccessIcon = () => (
  <svg class="f-toast__hud-icon" width="36" height="36" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M19.5707 7.37793L10.3797 16.5709L5.42969 11.6209"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="square"
    />
  </svg>
);

export interface ToastProps {
  message: string;
  type: ToastType;
  duration: number;
  position: ToastPosition;
  forbidClick: boolean;
  hud: boolean;
  close: () => void;
  api: ToastAPI;
}
export const ToastView = (props: ToastProps) => {
  const state = reactive({
    visible: true,
  });
  let closed = false;
  const handleClose = () => {
    if (closed) return;
    closed = true;
    state.visible = false;
    setTimeout(() => {
      props.close();
    }, 200);
  };
  onMount(() => {
    const d = props.duration;
    if (d > 0) {
      setTimeout(handleClose, d);
    }
  });
  props.api.handleClose = handleClose;
  const positionClass =
    props.position === 'top' ? 'f-toast--top' : props.position === 'bottom' ? 'f-toast--bottom' : 'f-toast--middle';
  return (
    <div
      class={props.forbidClick ? 'f-toast-overlay f-toast-overlay--forbid' : 'f-toast-overlay f-toast-overlay--through'}
    >
      <div
        class={`f-toast ${positionClass}${props.hud ? ' f-toast--hud' : ''} ${state.visible ? 'f-toast--show' : 'f-toast--hide'}`}
        onclick={(e: MouseEvent) => e.stopPropagation()}
      >
        {props.type === 'success' ? (props.hud ? <HudSuccessIcon /> : <Icon name="common-success" class="f-toast__icon" />) : null}
        {props.type === 'fail' ? <Icon name="common-fail" class="f-toast__icon" /> : null}
        {props.type === 'loading' ? (
          props.hud ? (
            <HudSpinnerIcon />
          ) : (
            <Icon name="common-loading" class="f-toast__icon f-toast__icon--spin" />
          )
        ) : null}
        {props.message ? <div class="f-toast__text">{props.message}</div> : null}
      </div>
    </div>
  );
};
